// frontend-api/public/config
// frontend-api/public/deliveryperiod
// frontend-api/canteen/get-next-canteen
// frontend-api/order
// frontend-api/order/track-deliveries
// frontend-api/public/restaurant/search
// frontend-api/public/restaurant/quick-search
// frontend-api/public/translations
// frontend-api/public/options
// frontend-api/user/clear-current-address

//app.ordit.hu
const appOrditUrls = [
    'api/v1/auth/login',
    'api/v1/auth/refresh',
    'api/v1/auth/resetting',
    'api/v1/auth/reset',
    'api/v1/auth/register',
    'api/v1/auth/activate',
    'api/v1/me',
    'api/v1/company-expense-rules',
    'api/v1/user-addresses',
    'api/v1/users',
    'api/v1/restaurants',
    'api/v1/calculate',
    'api/v1/order/check-item-existence',
    'api/v1/orders',
    'api/v1/tags',
    'api/v1/rate',
    'api/v1/ratings',
    'api/v1/settings',
    'api/v1/sap',
    'api/v1/residential-canteens',
    'api/v1/payment/stripe/create/setup-intent',
    'api/v1/payment/stripe/getPaymentMethods/card/all',
    'api/v1/payment/stripe/delete-card/',
]

export default function isDevOrdit(url) {
    return Boolean(appOrditUrls?.find((appOrditUrl) => url?.includes(appOrditUrl)))
}
